import React from "react";
import { Link } from "react-router-dom";
interface AuthLayoutProps {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
}
export default function AuthLayout({
  children,
  title,
  subtitle
}: AuthLayoutProps) {
  return <div className="min-h-screen flex items-center justify-center bg-background py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <Link to="/" className="inline-block">
            <img alt="TailorOS Logo" src="/lovable-uploads/a2493187-afa6-4015-84cc-ca15dbd52def.png" className="h-18 w-auto mx-auto" />
          </Link>
          <h2 className="mt-6 text-foreground font-bold text-3xl my-[14px]">{title}</h2>
          {subtitle && <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>}
        </div>
        {children}
        <div className="mt-6 text-center text-sm text-muted-foreground">
          <img alt="Powered by TailorOS" src="/lovable-uploads/4ae7ba1f-6bf1-4c7e-af81-053a6f13394c.png" className="h-6 w-auto mx-auto opacity-60 hover:opacity-100 transition-opacity" />
        </div>
      </div>
    </div>;
}